(function () {
    angular.module('PWAPoCApp').constant('appVersion', '20.09.0.55');
})();
